import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowDownIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.47083 9.92248V1.9845C7.47083 1.7105 7.69381 1.48837 7.96888 1.48837C8.24395 1.48837 8.46693 1.7105 8.46693 1.9845V9.92248C8.46693 10.1965 8.24395 10.4186 7.96888 10.4186C7.69381 10.4186 7.47083 10.1965 7.47083 9.92248Z"
      fill="currentColor"
    />
    <path
      d="M10.9374 6.26421C11.1319 6.07062 11.4472 6.07051 11.6417 6.26421C11.836 6.45792 11.836 6.77205 11.6417 6.96576L8.32068 10.2729C8.12618 10.4667 7.8109 10.4667 7.6164 10.2729L4.29636 6.96576C4.10186 6.77201 4.10186 6.45796 4.29636 6.26421C4.49086 6.07046 4.80614 6.07046 5.00064 6.26421L7.96854 9.2206L10.9374 6.26421Z"
      fill="currentColor"
    />
  </svg>
);
